module.exports = __webpack_public_path__ + "img/project5.823240cc.jpg";